// Función para encontrar una sucursal activa con documentos específicos
export const encontrarSucursalConDocs = (sucursales: Array<any>, iddocumento: string) => {
  return sucursales.find((sucursal) => 
    sucursal.activo === "true" &&
    sucursal.Asignado === true && 
    sucursal.Documento.find((doc:any) => doc.iddocumento === iddocumento && doc.estado === "true")
  );
};

// Función para encontrar la serie por defecto
export const encontrarSerieActiva = (Documentos: Array<any>, iddocumento: string) => {
  return Documentos.find((serie) => 
    serie.estado === "true" &&
    serie.iddocumento === iddocumento
  );
};